import { StarFilled } from '@ant-design/icons';
import Slider from 'react-slick';
import { motion } from 'motion/react';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ease = [0.22, 1, 0.36, 1];

const testimonials = [
  {
    id: 1,
    name: 'Priya Patil',
    rating: 5,
    text: 'The Ayurvedic fertility treatment at Veda Nova completely changed our journey. After years of trying, the personalized care and panchakarma therapy finally helped us conceive naturally.',
  },
  {
    id: 2,
    name: 'Rahul Joshi',
    rating: 5,
    text: 'The Panchakarma therapy was one of the best decisions I have made. I now feel more energetic, healthier, and stress-free. Highly recommended for anyone seeking natural healing.',
  },
  {
    id: 3,
    name: 'Sneha Kulkarni',
    rating: 5,
    text: 'After following the personalized Ayurvedic treatment and lifestyle guidance, my hormonal imbalance and digestion improved significantly. Thank you to the entire Veda Nova team.',
  },
  {
    id: 4,
    name: 'Anjali Deshmukh',
    rating: 5,
    text: 'Dealing with PCOS for years took a toll on me, but the doctors here designed a treatment plan that actually worked. My cycles are regular again and I feel like myself.',
  },
  {
    id: 5,
    name: 'Meera Sawant',
    rating: 4,
    text: 'The staff is warm, knowledgeable, and genuinely invested in your wellbeing. My prenatal Ayurvedic care here made my pregnancy so much smoother.',
  },
  {
    id: 6,
    name: 'Kavita Nair',
    rating: 5,
    text: 'Veda Nova helped me manage my postpartum recovery with such care. The combination of traditional therapies and modern diagnostics gave me confidence in every step.',
  },
  {
    id: 7,
    name: 'Shalini Rao',
    rating: 5,
    text: 'I came in for chronic stress and hormonal issues. The root-cause approach here is unlike anything I have experienced with conventional treatment before.',
  },
  {
    id: 8,
    name: 'Pooja Iyer',
    rating: 5,
    text: 'The fertility program at Veda Nova is thoughtfully designed. Every consultation felt personal, and the results speak for themselves. We are expecting our first child.',
  },
  {
    id: 9,
    name: 'Divya Mehta',
    rating: 4,
    text: 'From detox therapies to diet guidance, everything was tailored to my body type. I have never felt this balanced and healthy.',
  },
  {
    id: 10,
    name: 'Neha Kulkarni',
    rating: 5,
    text: 'Authentic Ayurveda combined with genuine compassion. The doctors took time to understand my history before recommending any treatment. Truly a wellness journey.',
  },
  {
    id: 11,
    name: 'Radhika Shah',
    rating: 5,
    text: 'My irregular periods and fatigue are finally under control after months of treatment here. I recommend Veda Nova to every woman struggling with hormonal health.',
  },
  {
    id: 12,
    name: 'Vaishnavi Pawar',
    rating: 5,
    text: 'The care team made me feel heard and supported throughout my fertility treatment. Grateful for their expertise and the gentle, natural approach to healing.',
  },
];

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 2500,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true,
        autoplaySpeed: 3000,
      },
    },
  ],
};

export default function Reviews() {
  return (
    <section className="w-full flex justify-center items-center bg-[#faf6ee] px-2 sm:px-6 lg:px-20 py-12 lg:py-8">
      <div className="w-full max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease }}
          className="flex flex-col items-center text-center px-4 m-8 lg:mb-10"
        >
          <p className="uppercase md:text-xl text-base font-extrabold text-brand-gold">
            Reviews
          </p>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-forest mt-3 lg:mt-4">
            Patient Reviews
          </h2>

          <p className="mt-3 lg:mt-4 max-w-xl text-sm lg:text-base text-gray-500">
            Read what our patients have to say about their fertility and
            wellness journey at VedaNova.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease }}
        >
          <Slider {...settings} className="reviews-slider">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="px-2 sm:px-4 py-2">
                <motion.div
                  whileHover={{ y: -8 }}
                  className="rounded-2xl shadow-lg p-5 sm:p-6 flex flex-col justify-between min-h-[220px] sm:min-h-[240px] border transition-shadow duration-500 hover:shadow-xl bg-[#064E3B]"
                  style={{
                    borderColor: 'rgba(255,255,255,0.1)',
                  }}
                >
                  <div>
                    <div className="flex mb-4">
                      {Array.from({ length: testimonial.rating }).map((_, i) => (
                        <StarFilled
                          key={i}
                          className="text-lg mr-1"
                          style={{ color: '#b69c66' }}
                        />
                      ))}
                    </div>

                    <p className="text-sm leading-relaxed italic text-white/90">
                      "{testimonial.text}"
                    </p>
                  </div>

                  <div
                    className="mt-6 pt-4 border-t"
                    style={{
                      borderColor: 'rgba(255,255,255,0.1)',
                    }}
                  >
                    <p className="font-semibold text-[#FDFCF8]">
                      {testimonial.name}
                    </p>
                  </div>
                </motion.div>
              </div>
            ))}
          </Slider>
        </motion.div>
      </div>
    </section>
  );
}